
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableContainer extends Vue {
  @Prop(Boolean) readonly loading!: boolean;
  @Prop(Boolean) readonly empty!: boolean;
  @Prop(Object) readonly config!: any;

  prev(): void {
    if (this.config.page > 1) {
      this.$emit("update:config", { ...this.config, page: this.config.page-- });
    }
  }

  next(): void {
    this.$emit("update:config", { ...this.config, page: this.config.page++ });
  }

  updatedLimit(val: string) {
    this.config.limit = parseInt(val);
  }
}
